/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from 'axios';

import { env } from 'config/env';
import { getSavedUserInfo } from 'providers/Auth';

export const api = axios.create({
  baseURL: env.url,
});

const TZ_HEADER = 'X-Custom-Tz-Diff';

async function addAuthTokenToRequest(config: AxiosRequestConfig): Promise<AxiosRequestConfig> {
  const token = getSavedUserInfo()?.token;

  if (!token) return config;

  const authorization = `Bearer ${token}`;

  const updatedConfig = {
    ...config,
    headers: {
      ...config.headers,
      authorization,

      [TZ_HEADER]: `${new Date().getTimezoneOffset()}`,
    },
  };

  return updatedConfig;
}

export const unauthedApi = axios.create({
  baseURL: env.url,
});

api.interceptors.request.use(addAuthTokenToRequest as any);

unauthedApi.interceptors.request.use(
  (config) =>
    ({
      ...config,
      headers: {
        ...config.headers,
        [TZ_HEADER]: `${new Date().getTimezoneOffset()}`,
      },
    }) as any,
);

export type ApiError = {
  message: string;
};

export interface SuccessData {
  ok: true;
}

export default api;
